module.exports = __webpack_public_path__ + "static/img/1032.06dc885.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1032.jpg
// module id = 214
// module chunks = 0